import cart from '@ppcp/cart';
import {isPluginConnected, getSetting} from '@ppcp/utils';
import {CartController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import PayPalGateway from '../gateways/PayPalGateway';

if (isPluginConnected()) {
    const settings = getSetting('ppcp_data');

    // Create PayPal gateway
    const gateway = new PayPalGateway({
        id: 'ppcp',
        cart,
        settings: settings,
        controller: null // Will be set after controller creation
    });

    // Create cart controller with gateway
    const controller = new CartController({
        id: 'ppcp',
        cart,
        context: new Context('cart'),
        gateway,
        settings
    });

    controller.initialize();
}